<template>
  <HKLHoverTooltip class="tooltip-outer">
    <template #default>
      <div
        v-if="!url"
        class="empty"
      >
        {{ content }}
      </div>
      <a
        v-else
        :href="url"
        target="_top"
      >
        {{ content }}
      </a>
    </template>
    <template #tips>
      <div v-if="!url">
        {{ $t('hint.venderInfoHint') }}
      </div>
      <slot v-else />
    </template>
  </HKLHoverTooltip>
</template>

<script>
import HKLHoverTooltip from './HKLHoverTooltip.vue'

export default {
  components: {
    HKLHoverTooltip,
  },
  props: {
    content: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      default () {
        return ''
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.tooltip-outer {
  .empty {
    text-decoration: underline;
    color: #1779ba;
    cursor: pointer;
  }
  a {
    text-decoration: underline;
  }
  &:hover {
    cursor: default;
  }
}
</style>
